import { isCustomizedType, reduce } from "et3-type-guards";
import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { getDateAsObject } from "../../core/et3-date";
import { post } from "../axios-post";

export const apiCallGeneratePromoCode = async ({
  description,
  benefitInHours,
  benefitType,
  startTime,
  expiryTime,
  maxUsage,
  promoCodeForGender,
  promoCodeForNationality,
  isActive,
  promoCodeForPaid,
  numberOfCodes
}: {
  description: string;
    benefitInHours: number;
    benefitType: string;
    startTime: Date;
    expiryTime: Date;
    maxUsage: number;
    promoCodeForGender: string;
    promoCodeForNationality: string;
    isActive: number;
    promoCodeForPaid: number;
    numberOfCodes: number;
}): Promise<{
  data: string[];
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<string[]>(
    `communications/generatePromoCode`,
    {
      description,
      benefitInHours,
      startTime: getDateAsObject(startTime),
      expiryTime: getDateAsObject(expiryTime),
      maxUsage,
      promoCodeForGender,
      isActive,
      promoCodeForPaid,
      promoCodeForNationality,
      benefitType,
      numberOfCodes
    }
  );

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: [],
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: [],
      status: "ERROR",
      code: "ERROR"
    };
  }
};
